import classNames from 'classnames';
import React from 'react';
import ProductLogo from '../ProductLogo/ProductLogo';
import Styles from './Header.module.scss';
import HeaderRight from './HeaderRight/HeaderRight';
import { HeaderSearch } from './Search/HeaderSearch';
import WorklistsDashboard from './WorklistsDashboard/WorklistsDashboard';

const {
    brandLogo: brandLogoStyle,
    environmentLabel: environmentLabelStyle,
    header: headerStyle,
    headerTest: headerTestStyle,
    header__content: headerContentStyle,
} = Styles;

function Header({ onClickLogo }: Readonly<{ onClickLogo: () => void }>): React.ReactElement {
    const isTestEnvironment = window.appConfig.UserConfigurableConfig.IsTestEnvironment;
    const testEnvironmentLabel = window.appConfig.UserConfigurableConfig.TestEnvironmentLabel;
    const testEnvironmentColor = window.appConfig.UserConfigurableConfig.TestEnvironmentHeaderColor;

    return (
        <div
            id={headerStyle}
            className={classNames(headerStyle, {
                [headerTestStyle]: true,
            })}
            style={{ '--test-header-color': testEnvironmentColor } as React.CSSProperties}
        >
            <button id={brandLogoStyle} type="button" onClick={onClickLogo}>
                <ProductLogo width="75%" />
            </button>
            <div className={headerContentStyle}>
                <HeaderSearch />
                <WorklistsDashboard />
                {isTestEnvironment && <div className={environmentLabelStyle}>{testEnvironmentLabel}</div>}
                <HeaderRight />
            </div>
        </div>
    );
}

export default Header;
